import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";

import Launcher from './Launcher';
import Widget from './Widget';
import Badge from './Badge';

const App = () => {
  const showLauncher = useSelector(state => state.launcher.showLauncher);
  const showWidget = useSelector(state => state.launcher.showWidget);
  const isDivWidget = useSelector(state => state.launcher.isDivWidget);

  if (!showLauncher) {
    return <></>;
  }

  return (
    <div className={"kil-chat kil-chat-full" + (showWidget ? ' active' : '') + (isDivWidget ? ' fullscreen' : '')}>
      {showWidget &&
        <>
        <Widget />
        </>
      }
      <Badge />
      <Launcher />
    </div>
  );
}

export default App;